<ng-container *ngIf="navigationItems && initialized">

    <div class="mt-5">

        @if (activeNavigationItem?.action == 'bankTransactionFamily') {
            <bm-bank-transaction-family-details [bankTransactionFamilyId]="objectIdentifier.objectId"></bm-bank-transaction-family-details>
        }

        @if (activeNavigationItem?.action == 'bankTransactionSubFamily') {
            <p>Banktransaktionssubfamilien</p>
        }
    </div>

</ng-container>
